import React from "react";

const LoadingIndicatorOverlay = ({ message }) => (
  <div className="cb-c-error-overlay">
    <div className="cb-c-error-overlay__message fable:p-2">{message}</div>
  </div>
);

export default LoadingIndicatorOverlay;
